import axios from "axios";
const BASE_URL =
  import.meta.env.VITE_API_URL || "https://unitstable-api.webapps.dev.rnl.io";
const API_KEY = import.meta.env.VITE_API_KEY || "test";
const API_SECRET = import.meta.env.VITE_API_SECRET || "test";

// const axiosInstance = axios.create({
//   baseURL: BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//     Authorization: "Basic " + btoa([API_KEY, API_SECRET].join(":")),
//   },
// });

export const Get = <T = unknown>(accessKey: string, url: string): Promise<T> =>
  axios
    .get<T>(BASE_URL + url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + btoa([API_KEY, API_SECRET].join(":")),
        "x-access-key": accessKey,
      },
    })
    .then((resp) => resp.data);

export const Post = <T = unknown, D = unknown>(
  accessKey: string,
  url: string,
  data: D
): Promise<T> =>
  axios
    .post<T>(BASE_URL + url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + btoa([API_KEY, API_SECRET].join(":")),
        "x-access-key": accessKey,
      },
    })
    .then((resp) => resp.data);

export const Put = <T = unknown, D = unknown>(
  accessKey: string,
  url: string,
  data: D
): Promise<T> =>
  axios
    .post<T>(BASE_URL + url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + btoa([API_KEY, API_SECRET].join(":")),
        "x-access-key": accessKey,
      },
    })
    .then((resp) => resp.data);
